import { render, staticRenderFns } from "./ConfigInputText.vue?vue&type=template&id=6569d62b&"
import script from "./ConfigInputText.vue?vue&type=script&lang=js&"
export * from "./ConfigInputText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6569d62b')) {
      api.createRecord('6569d62b', component.options)
    } else {
      api.reload('6569d62b', component.options)
    }
    module.hot.accept("./ConfigInputText.vue?vue&type=template&id=6569d62b&", function () {
      api.rerender('6569d62b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/configs/inputs/ConfigInputText.vue"
export default component.exports